/* eslint-disable max-lines-per-function */
import type { ReactNode } from 'react'
import classNames from 'classnames'
import Link from '@/components/Common/Link'
import {
  ANDROID_ONE_APP_LINK,
  IOS_ONE_APP_LINK,
  IOS_ONE_APP_LINK_INDSTOCKS,
} from '@/root/constants'
import Image from '@/components/Common/StencilImage'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import {
  EN_HOME_APP_STORE_CLICK,
  EN_HOME_PLAY_STORE_CLICK,
  LOB,
} from '@/root/utils/common/web/gtm-events/eventsList'
import { INDSTOCKS_HOST } from '@/root/constants/common'

const Wrapper: React.FC<{
  children: ReactNode
}> = ({ children }) => {
  return <div className="w-32 cursor-pointer md:w-40">{children}</div>
}
export default function MobileStores({
  links = true,
  diff = false,
  dontShowDownloadAppImages,
  fromHomePage = false,
  cssStyle,
  host,
}: {
  links?: boolean
  dontShowDownloadAppImages?: boolean
  fromHomePage?: boolean
  cssStyle?: string
  diff?: boolean
  host?: string
}) {
  const pushEvent = useAnalyticsEvent()
  if (dontShowDownloadAppImages) {
    return null
  }

  const isIndStocks = host === INDSTOCKS_HOST

  if (isIndStocks) {
    return (
      <div
        className={classNames(
          'flex flex-col items-end space-x-4 space-y-2 md:flex-row',
          cssStyle,
        )}
      >
        <Wrapper>
          {links ? (
            <Link
              href={
                diff
                  ? IOS_ONE_APP_LINK_INDSTOCKS
                  : 'https://indmoney.onelink.me/MgHh/i6daogy4'
              }
              openInNewTab
              onClick={e => {
                e.stopPropagation()
                if (fromHomePage) {
                  pushEvent({
                    gtmPayload: {
                      eventName: EN_HOME_APP_STORE_CLICK,
                      source: LOB.HOMEPAGE,
                      lob: LOB.HOMEPAGE,
                    },
                  })
                }
              }}
              title="Download IND Money app on app store"
            >
              <Image
                src="/common/footer/old-app-store.svg"
                alt="Download IND Money app on app store"
                width={2500}
                height={750}
              />
            </Link>
          ) : (
            <Image
              src="/common/footer/old-app-store.svg"
              alt="Download IND Money app on app store"
              width={2500}
              height={750}
              className="cursor-default"
            />
          )}
        </Wrapper>
        <Wrapper>
          {links ? (
            <Link
              href="https://play.google.com/store/apps/details?id=com.indmoney.indstocks"
              openInNewTab
              onClick={e => {
                e.stopPropagation()
                if (fromHomePage) {
                  pushEvent({
                    gtmPayload: {
                      eventName: EN_HOME_PLAY_STORE_CLICK,
                      source: LOB.HOMEPAGE,
                      lob: LOB.HOMEPAGE,
                    },
                  })
                }
              }}
              title="Download IND Money app on play store"
            >
              <Image
                src="/common/footer/old-play-store.svg"
                alt="Download IND Money app on play store"
                width={2500}
                height={750}
              />
            </Link>
          ) : (
            <Image
              src="/common/footer/old-play-store.svg"
              alt="Download IND Money app on play store"
              width={2500}
              height={750}
              className="cursor-default"
            />
          )}
        </Wrapper>
      </div>
    )
  } else
    return (
      <div
        className={classNames(
          'flex flex-col items-end space-x-4 space-y-2 md:flex-row',
          cssStyle,
        )}
      >
        <Wrapper>
          {links ? (
            <Link
              href={
                diff
                  ? IOS_ONE_APP_LINK
                  : 'https://indmoney.onelink.me/MgHh/s9utdn0x'
              }
              openInNewTab
              onClick={e => {
                e.stopPropagation()
                if (fromHomePage) {
                  pushEvent({
                    gtmPayload: {
                      eventName: EN_HOME_APP_STORE_CLICK,
                      source: LOB.HOMEPAGE,
                      lob: LOB.HOMEPAGE,
                    },
                  })
                }
              }}
              title="Download IND Money app on app store"
            >
              <Image
                src="/common/footer/old-app-store.svg"
                alt="Download IND Money app on app store"
                width={2500}
                height={750}
              />
            </Link>
          ) : (
            <Image
              src="/common/footer/old-app-store.svg"
              alt="Download IND Money app on app store"
              width={2500}
              height={750}
              className="cursor-default"
            />
          )}
        </Wrapper>
        <Wrapper>
          {links ? (
            <Link
              href={
                diff
                  ? ANDROID_ONE_APP_LINK
                  : 'https://indmoney.onelink.me/MgHh/s9utdn0x'
              }
              openInNewTab
              onClick={e => {
                e.stopPropagation()
                if (fromHomePage) {
                  pushEvent({
                    gtmPayload: {
                      eventName: EN_HOME_PLAY_STORE_CLICK,
                      source: LOB.HOMEPAGE,
                      lob: LOB.HOMEPAGE,
                    },
                  })
                }
              }}
              title="Download IND Money app on play store"
            >
              <Image
                src="/common/footer/old-play-store.svg"
                alt="Download IND Money app on play store"
                width={2500}
                height={750}
              />
            </Link>
          ) : (
            <Image
              src="/common/footer/old-play-store.svg"
              alt="Download IND Money app on play store"
              width={2500}
              height={750}
              className="cursor-default"
            />
          )}
        </Wrapper>
      </div>
    )
}
